// src/mocks/handlers.js
import { delay, http, HttpResponse } from 'msw';

const handlers = (handlerDelay = 500) => [
  http.get('*/api/v4/user/info', async () => {
    await delay(handlerDelay);
    return HttpResponse.json(
      {
        FirstName: 'Testy',
        LastName: 'McTest',
        Email: 'testy.mctest@eposnow.com',
        CompanyGuid: '94f5016b-c684-4141-8cef-cfd527a1d800',
        UILanguageTag: 'en-GB',
        CurrencySymbol: '£',
      },
      { status: 200 }
    );
  }),
  http.get('*/v1/user', async () => {
    await delay(handlerDelay);
    return HttpResponse.json(
      {
        data: {
          id: '94f5016b-c684-4141-8cef-cfd527a1d800',
          createdAt: '2022-06-13T22:02:38.812861Z',
          updatedAt: '2022-06-14T14:05:43.764873Z',
          deletedAt: null,
          fullName: 'Testy McTest',
          email: 'testy.mctest@eposnow.com',
          userName: 'testy.mctest',
          locale: 'en-GB',
          location: 'GB',
          isLockedOut: false,
          isTwoFactorEnabled: true,
          isEmailVerified: false,
        },
      },
      { status: 200 }
    );
  }),

  http.get('*/Feature', async () => {
    await delay(handlerDelay);
    return HttpResponse.json(
      [
        {
          FeatureId: 1,
          FeatureName: 'Testing',
        },
        {
          FeatureId: 3,
          FeatureName: 'MinimumOrderAmount',
        },
        {
          FeatureId: 4,
          FeatureName: 'ProductArchiving',
        },
        {
          FeatureId: 5,
          FeatureName: 'AlternativePurchaseOrderFormat',
        },
        {
          FeatureId: 7,
          FeatureName: 'MultipleChoiceProductScanning',
        },
        {
          FeatureId: 8,
          FeatureName: 'LostFocusPrompt',
        },
        {
          FeatureId: 9,
          FeatureName: 'BottleDeposit',
        },
        {
          FeatureId: 13,
          FeatureName: 'BarcodeScanningErrorModals',
        },
        {
          FeatureId: 30,
          FeatureName: 'PennyRounding',
        },
        {
          FeatureId: 32,
          FeatureName: 'PriceScheduling_AllProducts',
        },
        {
          FeatureId: 33,
          FeatureName: 'Internationalization',
        },
        {
          FeatureId: 38,
          FeatureName: 'LogoutAfterInactivity',
        },
        {
          FeatureId: 39,
          FeatureName: 'CurrentStockAndVolumeReport',
        },
        {
          FeatureId: 41,
          FeatureName: 'CourseFiring',
        },
        {
          FeatureId: 44,
          FeatureName: 'CashCounting',
        },
        {
          FeatureId: 46,
          FeatureName: 'CustomerEmailInvoice',
        },
        {
          FeatureId: 50,
          FeatureName: 'HeldOrderNotification',
        },
        {
          FeatureId: 51,
          FeatureName: 'IndustryVerticalisation_Terminology',
        },
        {
          FeatureId: 62,
          FeatureName: 'Till_ZeroPaddedNumPad',
        },
        {
          FeatureId: 70,
          FeatureName: 'TenderReferences',
        },
        {
          FeatureId: 75,
          FeatureName: 'Reporting_Homepage',
        },
        {
          FeatureId: 76,
          FeatureName: 'ResendEmailReceipts',
        },
        {
          FeatureId: 77,
          FeatureName: 'KDS_Bumpbar',
        },
        {
          FeatureId: 80,
          FeatureName: 'ManagerDeviceLicenseOverride',
        },
        {
          FeatureId: 85,
          FeatureName: 'ProductCatalogue',
        },
        {
          FeatureId: 88,
          FeatureName: 'CashDiscount',
        },
        {
          FeatureId: 89,
          FeatureName: 'CapitalGrants',
        },
      ],
      { status: 200 }
    );
  }),
  http.delete('*/v1/session', async () => new HttpResponse(null, { status: 200 })),
];

export default handlers;
